const addClass = (elem, className) => {
  if (elem)
    typeof elem.map == 'function' ? elem.map(_elem => _elem.classList.add(className)) : elem.classList.add(className);
};

const removeClass = (elem, className) => {
  if (elem)
    typeof elem.map == 'function' ? elem.map(_elem => _elem.classList.remove(className)) : elem.classList.remove(className);
};

// eslint-disable-next-line no-unused-vars
const toggleClass = (elem, className) => {
  if (elem)
    typeof elem.map == 'function' ? elem.map(_elem => _elem.classList.toggle(className)) : elem.classList.toggle(className);
};


const $ = document.querySelector.bind(document);
// eslint-disable-next-line no-unused-vars
const $$ = (...a) => Array.from(document.querySelectorAll.bind(document)(...a));
const makeHiddenByExpression = (elem, expression) => expression ? removeClass(elem, 'hidden') : addClass(elem, 'hidden');
// eslint-disable-next-line no-unused-vars
const hide = elem => {
  if (!elem) {
    return;
  }

  if (!elem.length) {
    makeHiddenByExpression(elem, false);
  } else {
    elem.map(_elem => makeHiddenByExpression(_elem, false));
  }
};
// eslint-disable-next-line no-unused-vars
const show = elem => {
  if (!elem) {
    return;
  }

  if (!elem.length) {
    makeHiddenByExpression(elem, true);
  } else {
    elem.map(_elem => makeHiddenByExpression(_elem, true));
  }
};

// eslint-disable-next-line no-unused-vars
function roundRect(ctx, x, y, width, height, radius, fill, stroke) {
  if (typeof stroke == 'undefined') {
    stroke = true;
  }
  if (typeof radius === 'undefined') {
    radius = 5;
  }
  if (typeof radius === 'number') {
    radius = {
      tl: radius,
      tr: radius,
      br: radius,
      bl: radius
    };
  } else {
    var defaultRadius = {
      tl: 0,
      tr: 0,
      br: 0,
      bl: 0
    };
    for (var side in defaultRadius) {
      radius[side] = radius[side] || defaultRadius[side];
    }
  }
  ctx.lineWidth = 1;
  ctx.strokeStyle = 'white';
  ctx.beginPath();
  ctx.moveTo(x + radius.tl, y);
  ctx.lineTo(x + width - radius.tr, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  ctx.lineTo(x + width, y + height - radius.br);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
  ctx.lineTo(x + radius.bl, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  ctx.lineTo(x, y + radius.tl);
  ctx.quadraticCurveTo(x, y, x + radius.tl, y);
  ctx.closePath();
  if (fill) {
    ctx.fill();
  }
  if (stroke) {
    ctx.stroke();
  }

}

// eslint-disable-next-line no-unused-vars
const app = {
  self: this,
  appWebHeight: 706,
  currentHeight: 706,
  isMob: undefined,
  appParams: null,
  now: undefined,
  tests: {},
  currentTestId: null,
  activePresentId: null,
  postImg: null,
  gender: 'male',
  questionsLen: 8,

  scr: [
    'scr_intro',
    'scr_question0',
    'scr_question1',
    'scr_question2',
    'scr_question3',
    'scr_question4',
    'scr_question5',
    'scr_question6',
    'scr_question7',
    'scr_feedback',
    'scr_result',
    'scr_badge_attached',
    'scr_posted',
    'scr_error'
  ],

  scrHeight: {
    scr_intro: 720,
    scr_question0: 706,
    scr_feedback: 1080,
    scr_result: 5236,
    scr_badge_attached: 1580,
    scr_posted: 1480,
    scr_error: self.appWebHeight
  },

    /**
     * Показывает экран приложения
     *
     * @param screenName - имя экрана, который следуюет показать. Из массива app.scr
     * @param hideOthers (true by default) - скрывать ли все отстальные экраны
     */
    // eslint-disable-next-line no-unused-vars
  showScreen: function(screenName, hideOthers) {
    'use strict';
    let self = this;
    self.previousScreen = self.currentScreen;
    self.currentScreen = screenName;
    if (hideOthers === undefined) {
      hideOthers = true;
    }
    for (var i = 0; i < self.scr.length; i++) {
      if (screenName === self.scr[i]) {
        show($('#id-'+self.scr[i]));
        if (document.scrollingElement) {
          document.scrollingElement.scrollTop = 0;
        }
      }
      else if (hideOthers === true){
        hide($('#id-'+self.scr[i]));
      }
    }
    self.setScreenHeight(screenName);
  },

    /**
     * Скрыть определенный экран
     *
     * @param screenName
     */
    // eslint-disable-next-line no-unused-vars
  hideScreen: function(screenName) {
    'use strict';
    let self = this;
    for (var i = 0; i < self.scr.length; i++) {
      if (screenName === self.scr[i]) {
        hide($('#id-' + self.scr[i]));
        break;
      }
    }
  },

  setScreenHeight: function(screenName) {
    'use strict';
    // do nothing
    // let self = this;
    // self.currentHeight = document.querySelector('main').offsetHeight || self.scrHeight[screenName] || self.appWebHeight;
    // self.resizeFrame(self.currentHeight);
  },

  resizeFrame: function(height) {
    FAPI.UI.setWindowSize(0, height);
  },

  currentQuestion: undefined,
  nextQuestion: function() {
    let self = this;
    if (self.currentQuestion === undefined) {
            // начало теста
      self.currentQuestion = 0;
    }
    else {
      self.currentQuestion++;
    }
    if (self.currentQuestion >= self.questionsLen) {
            // конец теста
      self.currentQuestion = undefined;
      self.showResult();
    }
    else {
      self.showScreen('scr_question' + self.currentQuestion);
    }
  },

  prevQuestion: function() {
    let self = this;
    if (self.currentQuestion === undefined) {
      self.currentQuestion = 0;
    }
    else {
      self.currentQuestion--;
    }

    if (self.currentQuestion == -1) {
            // начало теста
      self.currentQuestion = undefined;
      self.showScreen('scr_intro');
    }
    else {
      self.showScreen('scr_question' + self.currentQuestion);
    }
  },

  onStartTestClick: function() {
    this.nextQuestion();
  },

  initAppParams: function() {
    'use strict';
    let self = this;
    self.appParams = SessionHelper.getAppParams();
    if (self.apiServer) {
      ApiHelper.setApiServer(self.apiServer);
      self.appParams = SessionHelper.getAppParams(); // надо переписать параметры так как изменился api_server для FAPI
    } else if (self.appParams['app.api.server'] !== undefined || self.appParams['app.mobile.api.server'] !== undefined) {
            // если self.appParams['app.api.server'] существует, то его и устанавливаем
      self.apiServer = self.appParams['app.api.server'] || self.appParams['app.mobile.api.server'];
      ApiHelper.setApiServer(self.apiServer);
      self.appParams = SessionHelper.getAppParams(); // надо переписать параметры так как изменился api_server для FAPI
    }
    if (self.appParams['app.mobile.host'] !== undefined) {
      self.mobileHost = self.appParams['app.mobile.host'];
    }
  },

  API_callback: function(method, result, data) {
    if (method === "getPageInfo" && result === "ok") {
        data = JSON.parse(data);
        let height = Math.max(data.innerHeight - 76, 660);
        FAPI.UI.setWindowSize(data.innerWidth, height);
    }
  },

  isAppSupported: function() {
    return true;
  },

  initUIHandlers: function() {
    let self = this;
    $$('.js-open_test').map(elem => elem.addEventListener('click', e => self.onStartTestClick(e)));
    $$('.js-result').map(elem => elem.addEventListener('click', () => {
      if (elem.classList.contains('btn-disabled')) {
        return;
      }

      self.showScreen('scr_result');
    }));
    $$('.js-scroll').map(elem => elem.addEventListener('click', () => scrollTo($(elem.dataset.scrollto))));
        // $('.js-option').click(function(e){
        //     self.onOptionClick(e);
        // });

        // $('.js-attach_badge').click(function(e) {
        //     self.sendPresent(self.activePresentId);
        // });
        // $('.js-share').click(function(e) {
        //     self.share(self.postImg);
        // });

    $$('.artistWrap .artistName').map(elem => elem.addEventListener('mouseenter', () => {
      elem.tooltipTimeout = setTimeout(() => {
        addClass(elem, 'show-tooltip');
      }, 1500);
    }));

    $$('.artistWrap .artistName').map(elem => elem.addEventListener('mouseleave', () => {
      clearTimeout(elem.tooltipTimeout);
      removeClass(elem, 'show-tooltip');
    }));
  },

  start: function() {
    'use strict';
    let self = this;
    if (self.isAppSupported() === true) {
      self.initAppParams();
      if (self.appParams['app.finished']==='1' || self.appParams['app.mobile.finished']==='1') {
        self.showScreen('scr_finished');
      }
      else {
        window.API_callback = self.API_callback;
        if (self.isMob !== true) {
                    // eslint-disable-next-line no-undef
          FAPI.init(self.appParams.api_server, self.appParams.apiconnection,
                        function () {
                            // eslint-disable-next-line no-console
                          console.log('FAPI.init() successful');
                            // eslint-disable-next-line no-undef
                          // FAPI.UI.setWindowSize(0,self.currentHeight);
                          self.setScreenHeight();
                          FAPI.UI.getPageInfo();
                          let params = {
                            method: 'users.getCurrentUser',
                            application_key: appParams.application_key,
                            format: 'json',
                            session_key: appParams.session_key,
                            receiver_id: appParams.logged_user_id,
                          };

                          FAPI.Client.call(params, function(resultCode, result) {
                            try {
                              let pic;
                              if (result.pic_3.indexOf("https://i.mycdn.me/res/stub_") == -1 ) {
                                pic = result.pic_3;
                              } else if (result.gender == "male") {
                                pic = "assets/images/male.png";
                              } else {
                                pic = "assets/images/female.png";
                              }
                              $$('[data-user-image]').map(elem => { elem.src = pic; });
                              $$('[data-user-badge]').map(elem => { elem.src = `https://dp.mycdn.me/getImage?photoId=${presentID}&type=4`; });
                            } catch (e) {
                                    //
                            }
                          });
                        },
                        function (error) {
                            // eslint-disable-next-line no-console
                          console.log(error);
                            // eslint-disable-next-line no-console
                          console.log('FAPI.init() error');
                          addClass($('html'), 'no-fapi');
                        }
                    );
        }

        self.initUIHandlers();

        // iiii
        window.checkVoted();

        // eslint-disable-next-line no-undef
        ApiHelper.usersGetInfo(function(result, data) {
          if (result === 'ok') {
            self.gender = data[0].gender;
            let pic;
            if (data[0].pic288x288.indexOf("https://i.mycdn.me/res/stub_") == -1 ) {
              pic = data[0].pic288x288;
            } else if (result.gender == "male") {
              pic = "assets/images/male.png";
            } else {
              pic = "assets/images/female.png";
            }
            $$('[data-user-image]').map(elem => { elem.src = pic; });
          }
        }, self.appParams.logged_user_id, 'user.gender,user.pic288x288', self.appParams);
      }
    }
    else {
      self.showScreen('scr_notsup');
    }

    if (navigator.userAgent.indexOf('Opera Mini') > -1) {
      document.documentElement.className += ' opera-mini';
    }
  },
};
